export const PlatformOptions = [
  {
    value: "FACEBOOK",
    iconPath: "/icons/social-icons/facebook.svg",
    text: "Facebook",
  },
  {
    value: "WHATSAPP",
    iconPath: "/icons/social-icons/whatsapp.svg",
    text: "Whatsapp",
  },
  {
    value: "TWITTER",
    iconPath: "/icons/social-icons/twitter.svg",
    text: "Twitter",
  },
  {
    value: "INSTAGRAM",
    iconPath: "/icons/social-icons/instagram.svg",
    text: "Instagram",
  },
  {
    value: "DISCORD",
    iconPath: "/icons/social-icons/discord.svg",
    text: "Discord",
  },
  {
    value: "LINKEDIN",
    iconPath: "/icons/social-icons/linkedin.svg",
    text: "Linkedin",
  },
];
